import { FieldNames } from 'Constants/FieldNames'

export enum KindType {
	agreement = 'Agreement',
	anketafsc = 'AnketaFSC',
	benefinfo = 'BenefInfo',
	bigdealagreement = 'BigDealAgreement',
	bigdealprotocol = 'BigDealProtocol',
	changedguaranteeblank = 'ChangedGuaranteeBlank',
	debtletter = 'DebtLetter',
	egrul = 'EGRUL',
	financialstatement = 'FinancialStatement',
	gendirscan = 'GenDirScan',
	guaranteeblank = 'GuaranteeBlank',
	ipscan = 'IPScan',
	procuratory = 'Procuratory',
	protocolgendirscan = 'ProtocolGenDirScan',
	newguaranteeblank = 'NewGuaranteeBlank',
	oferta = 'Oferta',
	ustav = 'Ustav',
	otherdocs = 'OtherDocs',
	statementckr = 'StatementCKR',
	managerguaranteeblank = 'ManagerGuaranteeBlank',
	guaranteetemplate = 'GuaranteeTemplate',
	paymenttemplate = 'PaymentTemplate',
	supportdoc = 'SupportDoc',
	powerofattorneyjur = 'PowerofattorneyJur',
	agreement_director_sign = 'Agreement_director_sign',
}

export enum DocumentsForSendType {
	STATEMENTCKR = FieldNames.STATEMENTCKR,
	MANAGERGUARANTEEBLANK = FieldNames.MANAGERGUARANTEEBLANK,
	PAYMENTTEMPLATE = FieldNames.PAYMENTTEMPLATE,
	SIGN_TRUST_DOCUMENT = FieldNames.SIGN_TRUST_DOCUMENT,
}

export const DocumentsForSendTypeTranslate = {
	[DocumentsForSendType.STATEMENTCKR]: 'Выписка из реестра',
	[DocumentsForSendType.MANAGERGUARANTEEBLANK]: 'Гарантия',
	[DocumentsForSendType.PAYMENTTEMPLATE]: 'Платежное поручение',
	[DocumentsForSendType.SIGN_TRUST_DOCUMENT]: 'Доверенность',
}
